<header class="hero-section">
    <img alt="Institution Logo" class="top-logo" src="logo-login.svg">
    <div class="hero-content container">
        <h1 class="display-3 fw-bold mb-4">Complete Institution Solutions</h1>
        <p class="lead mb-4">
            Transform your educational institution with our comprehensive Institute Management System
            and enhance communication with our mobile application for employees, parents and students.
        </p>
        <div class="mt-5">
            <a class="btn btn-primary btn-lg px-5 me-md-2" routerLink="/admission">New Admission</a>
            <a class="btn btn-outline-light btn-lg px-5" href="https://ainstitute.cloud">Learn More</a>
        </div>
        <footer class="mt-5 pt-4 border-top border-secondary">
            <p class="lead opacity-75">
                We are proudly supported by <strong>Nythova Data Lab LLC, a U.S</strong> registered company.
            </p>
        </footer>
    </div>
</header>
